import { render, staticRenderFns } from "./SortableListItem.vue?vue&type=template&id=61514ce8&scoped=true&"
import script from "./SortableListItem.vue?vue&type=script&lang=js&"
export * from "./SortableListItem.vue?vue&type=script&lang=js&"
import style0 from "./SortableListItem.vue?vue&type=style&index=0&id=61514ce8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61514ce8",
  null
  
)

export default component.exports